import UserProfileDetailsPage from "./user-profile-page.jsx";
import EditUserProfilePage from "./edit-profile-page.jsx";
import AuthorProfilePage from "./author-profile-page.jsx";
import AuthorProfileApprovalsPage from "./author-profile-approvals-page.jsx";

const userSettingsRoutes = [
  {
    path: "/user-settings/profile",
    name: "User Profile",
    component: UserProfileDetailsPage,
    dontShowInSideBar: true,
  },
  {
    path: "/user-settings/edit-profile",
    name: "Edit User Profile",
    component: EditUserProfilePage,
    dontShowInSideBar: true,
  },
  {
    path: "/user-settings/author-profile",
    name: "Author Profile",
    component: AuthorProfilePage,
    dontShowInSideBar: true,
  },
  {
    path: "/user-settings/author-profile-approvals",
    name: "Author Profile Approvals",
    component: AuthorProfileApprovalsPage,
    dontShowInSideBar: true,
  }
];

export default userSettingsRoutes; 